import { Config } from "../config"
import { resolveCssSelector } from "./resolveCssSelector"
import { bindInput as bindInputListeners, InputBindingCallbacks } from "@nosto/search-js/utils"

export function bindInput(
    config: Config,
    target: HTMLInputElement,
    callbacks: InputBindingCallbacks
): {
    destroy: () => void
} {
    const dropdownLocator = resolveCssSelector(config.dropdownCssSelector)
    const formContainer = dropdownLocator && document.querySelector(dropdownLocator.selector)

    const formEl = formContainer ? formContainer.querySelector("form") : target.form
    return bindInputListeners(target, callbacks, { form: formEl! })
}
